import { useReactiveVar } from '@apollo/client/react';
import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { rootRouteModeVar } from './reactiveRoutes';
import { routesByMode } from './routes';

const AppRouter = () => {
  const mode = useReactiveVar(rootRouteModeVar);
  const router = useMemo(() => createBrowserRouter(routesByMode[mode]), [mode]);

  return <RouterProvider key={mode} router={router} />;
};

export default AppRouter;
